import {MutationTree} from 'vuex';
import {ProfileState} from '@/store/modules/Profile/state';
import {AuthorProfile, BlackListUser, MyProfileAPI, ProfilDetailAPI} from '#/User';

export const mutations: MutationTree<ProfileState> = {
  GET_AUTHOR_PROFILE: (
      state: ProfileState,
      profile: AuthorProfile
  ): void => {
    state.authorProfile = profile
  },

  GET_PROFILE: (state: ProfileState, profile: MyProfileAPI): void => {
    state.profile = profile
    state.profileStored = true
  },

  LOAD_BLACKLIST: (state: ProfileState, blacklist: BlackListUser[]): void => {
    state.profile.blacklist = blacklist
  },

  UPDATE_BLACKLIST: (state: ProfileState, user: ProfilDetailAPI): void => {
    const { id, name } = user
    state.profile.blacklist = state.profile.blacklist.some(bl => bl.id === id)
                              ? state.profile.blacklist.filter(bl => bl.id !== id)
                              : [...state.profile.blacklist, { id, name }]
  },
}
